export default __webpack_public_path__ + "static/media/ProductSans-Regular.9c6cd8c7.eot";